import React, {useState} from "react";

//Ant design imports
import { ConfigProvider, Select } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  WarningOutlined,
} from "@ant-design/icons";

//project imports
import appStatic from "../config/appStatic";

const StatusSelect = (props) => {
  const { listStatusData } = appStatic;
  const { handleStatusChange, colorBgContainer, colorText } = props;
  const [authSelectColour, setAuthSelectColor] = useState("#1bb394");

  const iconMap = {
    Active: <CheckOutlined />,
    Unauthorised: <CloseOutlined />,
    Disabled: <WarningOutlined />,
  };

  const renderOption = (label) => (
    <span>
      {iconMap[label]} {label}
    </span>
  );

  function onSelect(value) {
    switch (value.toLowerCase()) {
      case 'active':
        return setAuthSelectColor("#1bb394"); 
        case 'disabled':
          return setAuthSelectColor("#ed5565");
      default:
        return setAuthSelectColor("#fff");
    }
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgContainer: authSelectColour,
          colorText: colorText,
        },
      }}
    >
      <Select
        defaultValue={listStatusData[0].value}
        prefixCls="test"
        options={listStatusData.map((status) => ({
          ...status,
          label: renderOption(status.label),
        }))}
        onChange={handleStatusChange}
        onSelect={onSelect}
      />
    </ConfigProvider>
  );
};

export default StatusSelect;
